<template>
  <b-row class="npfsummaryrow">
    <b-col cols="5">
      <span class="npfQuestion">{{title}}</span>
    </b-col>
    <b-col cols="5">
      <span class="npfSubQuestion">{{cleanedAnwser}}</span>
    </b-col>
    <b-col cols="2">
      <b-button size="sm" v-on:click="editClick()" variant="primary">
        <font-awesome-icon :icon="['fas', 'edit']"></font-awesome-icon>&nbsp; Edit
      </b-button>
    </b-col>
  </b-row>
</template>

<script>
export default {
  props: ["title", "answer", "pagenum"],
  data() {
    return {
      ethnicity: [
        { value: "PS", text: "*** Please Select ***" },
        { value: "A09", text: "Any other Asian background" },
        { value: "B09", text: "Any other Black background" },
        { value: "O09", text: "Any other ethnic group" },
        { value: "M09", text: "Any other mixed background" },
        { value: "W09", text: "Any other white background" },
        { value: "A2H", text: "Arab" },
        { value: "A03", text: "Asian - Bangladeshi" },
        { value: "A01", text: "Asian - Indian" },
        { value: "A02", text: "Asian - Pakistani" },
        { value: "B02", text: "Black African" },
        { value: "B01", text: "Black Caribbean" },
        { value: "O01", text: "Chinese" },
        { value: "G02", text: "Gypsy or Irish Traveller" },
        { value: "N03", text: "Prefer not to say" },
        { value: "M03", text: "White & Asian" },
        { value: "M02", text: "White & Black African" },
        { value: "M01", text: "White & Black Caribbean" },
        { value: "W01", text: "White British" },
        { value: "W02", text: "White Irish" }
      ]
    };
  },
  computed: {
    // a computed getter
    cleanedAnwser: function() {
      // `this` points to the vm instance
      var returnValue = this.answer;
    if (returnValue === true) {
        return "Yes";
      }
       if (returnValue === false) {
           return "No"
      }
      if (returnValue == "//") {
        return "";
      }
      if (returnValue == "M") {
        return "Male";
      }
      if (returnValue == "F") {
        return "Female";
      }
      if (returnValue == "O") {
        return "Other";
      }
      if (returnValue == "PNS") {
       return "Prefer not to say";
      }
      var ethnicity = this.doesvalueexitsinEthnicity(returnValue);
      if (ethnicity.length > 0) {
        return ethnicity;
      }

      return returnValue;
    }
  },

  methods: {
    editClick() {
      this.$emit("gotToedit", this.pagenum);
    },
    doesvalueexitsinEthnicity: function(val) {
      var rval = "";

      this.ethnicity.forEach(function(value, key) {
        if (value.value === val) rval = value.text;
      });

      return rval;
    }
  }
};
</script>

<style>
</style>
